import { NgModule, Component, ElementRef, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';
import { Utilities } from '@shared/models/utilities/utilities.class';
import { Chart, registerables, ChartType } from 'chart.js';

// Register all Chart.js components (controllers, elements, scales, plugins)
Chart.register(...registerables);

@Component({
    selector: 'shopbox-chart',
    template: `
        <div style="position:relative" [ngStyle]="styleObj()">
          @if ((width !== '0') && (height !=='0')) {
            <canvas [id]="uid" [width]="width" [height]="height"
            [ngStyle]="styleObj()" (click)="onCanvasClick($event)"></canvas>
          }
          <!-- <div id="do_legend"></div> -->
        </div>
        `,
    imports: [NgStyle]
})
export class UIChartComponent implements AfterViewInit, OnDestroy {

  @Input() type: string;

  @Input() options: any;

  @Input() width: string;

  @Input() height: string;

  @Output() onDataSelect: EventEmitter<any> = new EventEmitter();

  initialized: boolean;

  _data: any;

  chart: any;
  uid = new Utilities().randomGenerator();

  constructor(public el: ElementRef) { }

  @Input() get data(): any {
    return this._data;
  }

  set data(val: any) {
    this._data = val;
    this.reinit();
  }

  ngAfterViewInit() {
    this.initChart();
    this.initialized = true;
  }

  onCanvasClick(event: any) {
    if (this.chart) {
      const elements = this.chart.getElementsAtEventForMode(
        event,
        'nearest',
        { intersect: true },
        false
      );
      const dataset = this.chart.getElementsAtEventForMode(
        event,
        'dataset',
        { intersect: true },
        false
      );
      if (elements && elements[0] && dataset) {
        this.onDataSelect.emit({ originalEvent: event, element: elements[0], dataset: dataset });
      }
    }
  }

  initChart() {
    const canvas = this.el.nativeElement.children[0]?.children[0] as HTMLCanvasElement;
    if (canvas) {
      this.chart = new Chart(canvas, {
        type: this.type as ChartType,
        data: this.data,
        options: this.options
      });
    }
  }

  getCanvas() {
    return this.el.nativeElement.children[0].children[0];
  }

  getBase64Image() {
    return this.chart?.toBase64Image();
  }

  generateLegend() {
    // Note: generateLegend was removed in Chart.js v3
    // Legend is now configured via options.plugins.legend
    console.warn('generateLegend() is deprecated in Chart.js v4. Configure legend via options.plugins.legend');
  }

  styleObj() {
    if (this.width !== '0' && this.height !== '0') {
      return { 'width': this.width + 'px', 'height': this.height  + 'px'};
    }
    return {};
  }

  refresh() {
    if (this.chart && this.chart.update) {
      this.chart.update();
    }
  }

  reinit() {
    if (this.chart && this.chart.clear && this.chart.destroy) {
      this.chart.clear();
      this.chart.destroy();
      this.initChart();
    }
  }

  ngOnDestroy() {
    if (this.chart && this.chart.destroy) {
      this.chart.destroy();
      this.initialized = false;
      this.chart = null;
    }
  }
}


